/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRocketLaunchIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-rocket-launch"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.08 12.43Q6.95 10.63 7.97 8.91Q9 7.2 10.28 5.65L8.72 5.35Q8.07 5.22 7.44 5.41Q6.8 5.6 6.33 6.08L3.15 9.25Q2.65 9.75 2.77 10.43Q2.9 11.1 3.55 11.38ZM21.38 2.17Q18.88 2.23 16.63 3.27Q14.38 4.33 12.6 6.1Q11.25 7.45 10.22 9Q9.2 10.55 8.47 12.28Q8.28 12.68 8.32 13.11Q8.38 13.55 8.68 13.85L11.07 16.23Q11.38 16.52 11.8 16.59Q12.22 16.65 12.63 16.45Q14.35 15.7 15.91 14.69Q17.48 13.68 18.82 12.32Q20.6 10.55 21.64 8.3Q22.68 6.05 22.73 3.55Q22.73 3.27 22.63 3.04Q22.52 2.8 22.32 2.6Q22.13 2.4 21.89 2.29Q21.65 2.17 21.38 2.17ZM15.28 9.63Q15.28 9.63 15.03 9.38Q14.78 9.13 14.78 8.39Q14.78 7.65 15.28 7.15Q15.78 6.65 16.51 6.65Q17.25 6.65 17.75 7.15Q18.25 7.65 18.25 8.39Q18.25 9.13 17.75 9.63Q17.25 10.13 16.51 10.13Q15.78 10.13 15.28 9.63ZM12.45 18.82L13.53 21.35Q13.8 22 14.47 22.13Q15.15 22.25 15.65 21.75L18.82 18.57Q19.3 18.1 19.49 17.46Q19.68 16.82 19.55 16.18L19.25 14.63Q17.7 15.93 15.97 16.94Q14.25 17.95 12.45 18.82ZM3.38 16.8Q4.35 15.82 5.74 15.81Q7.13 15.8 8.1 16.77Q9.07 17.75 9.06 19.14Q9.05 20.52 8.07 21.5Q6.78 22.8 4.96 23.06Q3.15 23.32 1.35 23.52Q1.55 21.73 1.81 19.91Q2.08 18.1 3.38 16.8Z" fill={color} />
    </svg>
  );
}
